import React from "react";
import Typography from "@material-ui/core/Typography";
const Payment = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Payment
      </Typography>
      <Typography paragraph variant="h5">
        Manage A/R and A/P payment to be more professional
      </Typography>
      <Typography paragraph variant="body1">
        Payment is one of the features under the Finance module to perform
        payment transactions particularly to handle customer payment processes
        for accounts receivable flow and vendor payment processes for accounts
        payable flow. It contains any information regarding the customer or
        vendor bank account, currency & exchange rate used for the transaction,
        and the payment amount.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Payment list.
        There are 2 types of Payment list: Accounts Receivable Payment list and
        Accounts Payable Payment list. It is displayed like a table that
        contains download functions, sort, filter, and global search on the
        header area, and contains data navigation and refresh function on the
        footer area. The data column that appears in this table list are listed
        below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Receivable Payment</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/R Payment ID</b>
        <br />
        Indicates the ID of the Accounts Receivable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Name</b>
        <br />
        Indicates the name of the Customer.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Payment Date</b>
        <br />
        Indicates the payment date of the Accounts Receivable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/R Invoice ID</b>
        <br />
        Indicates the ID of the Accounts Receivable Invoice related to Accounts
        Receivable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Cash Account</b>
        <br />
        Indicates the cash account of the Accounts Receivable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Payment Amount</b>
        <br />
        Indicates the payment amount of the Accounts Receivable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Payable Payment</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/P Payment ID</b>
        <br />
        Indicates the ID of the Accounts Payable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Vendor Name</b>
        <br />
        Indicates the name of the Vendor.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Payment Date</b>
        <br />
        Indicates the payment date of the Accounts Payable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/P Invoice ID</b>
        <br />
        Indicates the ID of the Accounts Payable Invoice related to Accounts
        Payable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Cash Account</b>
        <br />
        Indicates the cash account of the Accounts Payable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Payment Amount</b>
        <br />
        Indicates the payment amount of the Accounts Payable Payment.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 2 buttons that appear on each row of Accounts
        Receivable Payment and Accounts Payable Payment data with specific
        conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Receivable Payment</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Account Receivable Payment Detail</b>
        <br />
        This button is used to navigate to the Accounts Receivable Payment
        detail which contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Accounts Receivable
            Payment data.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Accounts Receivable Payment.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Accounts Receivable Payment.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Account Receivable Payment</b>
        <br />
        This button is used to delete the Accounts Receivable Payment data. The
        Accounts Receivable Payment data is undeletable once it has relations
        with other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>For Accounts Payable Payment</b>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Account Payable Payment Detail</b>
        <br />
        This button is used to navigate to the Accounts Payable Payment detail
        which contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Accounts Payable
            Payment data.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Accounts Payable Payment.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Accounts Payable Payment.
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Account Payable Payment</b>
        <br />
        This button is used to delete the Accounts Payable Payment data. The
        Accounts Payable Payment data is undeletable once it has relations with
        other documents.
      </Typography>
    </React.Fragment>
  );
};

export default Payment;
